export const timeStamp = () => {
  return Date.now();
};
